export const MENU_ORDER_CUSTOMER_SERVICE = '#customerServices';
export const MENU_ORDER_STOCK = '#stock';
export const MENU_ORDER_ARCHIVE = '#archive';
